import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLegalTopicsList } from '../../../../selectors/legal-topics';
import MenuDropdown from '../menu-dropdown';

const LegalTopicsDropdown = ({ messages }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const legalTopics = useSelector(getLegalTopicsList);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                className="navLink"
                id="legal-topics-button"
                aria-controls={open ? 'legal-topics-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                disableFocusRipple
            >
                {messages.legalTopicsLabel} <ArrowDropDownIcon />
            </Button>
            <MenuDropdown
                id="legal-topics-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'legal-topics-button',
                }}
            >
                {legalTopics.map(({ id, name }) => (
                    <MenuItem
                        onClick={() => {
                            navigate(`/legal-topics/${id}`);
                            handleClose();
                        }}
                        key={id}
                    >
                        {name}
                    </MenuItem>
                ))}
            </MenuDropdown>
        </div>
    );
};

LegalTopicsDropdown.propTypes = {
    messages: PropTypes.object.isRequired,
};

export default LegalTopicsDropdown;
